import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../../lib/api';
import { usePageTitle } from '../../lib/usePageTitle';
import { AuthLayout } from '../../components/AuthLayout';

type State = 'verifying' | 'success' | 'error';

export function VerifyEmailPage() {
  usePageTitle('Verifica email');
  const [searchParams] = useSearchParams();
  const [state, setState] = useState<State>('verifying');
  const [errorMessage, setErrorMessage] = useState('');
  const started = useRef(false);

  useEffect(() => {
    // StrictMode monta due volte: il token è monouso, verifichiamo una volta sola.
    if (started.current) return;
    started.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setState('error');
      setErrorMessage('Link non valido: manca il codice di verifica.');
      return;
    }
    api('/auth/verify-email', { method: 'POST', body: { token } })
      .then(() => setState('success'))
      .catch((err) => {
        setState('error');
        setErrorMessage(
          err instanceof ApiError ? err.message : 'Qualcosa è andato storto. Riprova.',
        );
      });
  }, [searchParams]);

  return (
    <AuthLayout title="Verifica email">
      {state === 'verifying' && <p role="status">Verifica in corso…</p>}
      {state === 'success' && (
        <>
          <p role="status" className="text-lg">
            <span aria-hidden="true">✓ </span>Email confermata! Il tuo account è attivo.
          </p>
          <p className="mt-6">
            <Link to="/accedi" className="text-panda-700 underline dark:text-panda-300">
              Vai alla pagina di accesso
            </Link>
          </p>
        </>
      )}
      {state === 'error' && (
        <>
          <p role="alert" className="font-medium text-danger">
            {errorMessage}
          </p>
          <p className="mt-6">
            <Link to="/accedi" className="text-panda-700 underline dark:text-panda-300">
              Torna all’accesso
            </Link>
          </p>
        </>
      )}
    </AuthLayout>
  );
}
